import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AvatarModule } from '../../components/avatar/avatar.module';
import { MergeUsersModalModule } from '../../components/merge-users-modal/merge-users-modal.module';

import { AdminPeopleRoutingModule } from './admin-people-routing.module';
import { AdminPeopleComponent } from './admin-people.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminPeopleRoutingModule,
    NgxDatatableModule,
    AvatarModule,
    MergeUsersModalModule,
    NgxTippyModule,
    SharedPipesModule,
  ],
  declarations: [AdminPeopleComponent],
})
export class AdminPeopleModule {}
